import React, { useEffect, useRef } from 'react';
import "./Aboutpage.css";


import Navbar from './Navbar';
import BackgroundImage from './Aboutus.jpg';

const Aboutpage = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('shutter-effect');
        } else {
          entry.target.classList.remove('shutter-effect');
        }
      });
    };
  
    const createObserver = () => {
      const threshold = window.innerWidth < 768 ? 0.1 : 0.25;
      const observer = new IntersectionObserver(observerCallback, { threshold });
      if (aboutRef.current) {
        observer.observe(aboutRef.current);
      }
      return observer;
    };
  
    const observer = createObserver();
  
    const handleResize = () => {
      observer.disconnect();
      createObserver();
    };
  
    window.addEventListener('resize', handleResize);
  
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
     <Navbar isHome={false} />



     <section ref={aboutRef} className="about-f py-3 py-md-5">
        <div className="container">
          <div className="row gy-3 gy-md-4 gy-lg-0 align-items-lg-center">
           
            <div className="col-12 col-lg-12">
              <div className="row justify-content-xl-center">
                <div className="col-12 col-xl-12">
                  <h1 className="mb-3 text-white">
                  About <span className="text-danger"><span style={{textTransform:"uppercase"}}>U</span>s</span>
                  </h1>
                  <p className="para  mb-3 mb-xl-5 "style={{textAlign:"justify",wordSpacing:"1px"}}>
                  Property92.pk is the Real Estate Turnkey Solution Provider Company in the country having its strengths in diverse businesses in converting your Raw Land into value added projects, totally compatible to the futuristic vision.
                  </p>
                  <p className=" para mb-3 mb-xl-5 "style={{textAlign:"justify",wordSpacing:"4px"}}>
                  The Property92.pk Company is fully geared to take complete charge of your real estate ventures. Alhamdu Lillah we have been working in the dynamic and ever changing market environment for approximately 3 decades and have been successful in living up to the commitments we made to our clients.
                  </p>
                  <p className=" para mb-3 mb-xl-5 "style={{textAlign:"justify",wordSpacing:"1px"}}>
                  Our mission statement is an obligatory promise. We make a long-term assessment in our dealings, strengthening Property92.pk as a brand whilst concerning to ensure comfort for the customers.
                  </p>
                 
                 
                  
                 
                </div>
              </div>
            </div>
           
          </div> <div className="col-12 col-lg-12 about-main" >
              <img
                className="img-fluid rounded img-para"
                loading="lazy"
                src={BackgroundImage}
                alt="About 2"
              />
            </div>
        </div>
       
      </section>














      







      
    </>
  );
};

export default Aboutpage;
